import * as dayjs from 'dayjs';
export function utcToBJ(value, formatRule) {
    if (formatRule === void 0) { formatRule = 'YYYY.MM.DD HH:mm'; }
    return dayjs(value).format(formatRule);
}
